<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="设备编号">
                <a-input v-model="queryParam.devCode" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="水表编号">
                <a-input v-model="queryParam.devSn" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.faultStatus" show-search :filter-option="filterOption" placeholder="请选择">
                  <a-select-option v-for="(item,key) in [{name:'待处理',id:0},{name:'处理成功',id:1},{name:'拒绝处理',id:2}]" :key="key" :value="item.id">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="是否生成退款订单">
                <a-select v-model="queryParam.sfRefundOrder" show-search :filter-option="filterOption" placeholder="请选择">
                  <a-select-option v-for="(item,key) in [{name:'否',id:0},{name:'是',id:1}]" :key="key" :value="item.id">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 4 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['gwisdom:fault:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['gwisdom:fault:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['gwisdom:fault:remove']">
          <a-icon type="delete" />删除
        </a-button> -->
        <!-- <a-button type="primary" @click="handleExport" v-hasPermi="['gwisdom:fault:export']">
          <a-icon type="download" />导出
        </a-button> -->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :typeOptions="dict.type['sys_yes_no']"
        @ok="getList"
      />
      <!-- 详情 -->
      <info
        ref="info"
        :typeOptions="dict.type['sys_yes_no']"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered">
        <span slot="faultStatus" slot-scope="text, record">
          <a-tag color="orange" v-if="record.faultStatus == 0">待处理</a-tag>
          <a-tag color="green" v-else-if="record.faultStatus == 1">处理成功</a-tag>
          <a-tag color="red" v-else-if="record.faultStatus == 2">拒绝处理</a-tag>
        </span>
        <span slot="sfRefundOrder" slot-scope="text, record">
          <a-tag color="blue" v-if="record.sfRefundOrder == 0">否</a-tag>
          <a-tag color="orange" v-else-if="record.sfRefundOrder == 1">是</a-tag>
        </span>
        <span slot="startTime" slot-scope="text, record">
          {{ parseTime(record.startTime) }}
        </span>
        <span slot="endTime" slot-scope="text, record">
          {{ parseTime(record.endTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.info.info(record.id)" v-hasPermi="['wisdom:device:page']"><a-icon type="eye"/>详情</a>
          <a-divider type="vertical" v-hasPermi="['wisdom:fault:add']" v-if="record.faultStatus == 0"/>
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['wisdom:fault:add']" v-if="record.faultStatus == 0">
            <a-icon type="edit" />处理
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>

import { faultPage, faultStatus } from '@/api/pages/fault'
import { tableMixin } from '@/store/table-mixin'
import CreateForm from './modules/CreateForm'
import Info from './modules/info'

export default {
  name: 'Config',
  mixins: [tableMixin],
  dicts: ['sys_yes_no'],
  components: {
    CreateForm, Info
  },
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      refreshing: false,
      total: 0,
      // 日期范围
      dateRange: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        dataInfoId: undefined
      },
      columns: [
        // {
        //   title: '订单号',
        //   dataIndex: 'orderNo',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '设备名称',
          dataIndex: 'devName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '设备类型',
          dataIndex: 'typeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '设备编号',
          dataIndex: 'devCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '水表编号',
          dataIndex: 'devSn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '故障类型',
          dataIndex: 'faultTypeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'faultStatus',
          scopedSlots: { customRender: 'faultStatus' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '处理说明',
        //   dataIndex: 'rejectCause',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '生成退款订单',
          dataIndex: 'sfRefundOrder',
          scopedSlots: { customRender: 'sfRefundOrder' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '退款金额',
          dataIndex: 'refundAmount',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '添加时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          width: 160,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 130,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询参数列表 */
    getList () {
      this.loading = true
      faultPage(this.queryParam).then(response => {
          this.list = response.data.records
          this.total = response.data.total
          this.loading = false
        }
      )
    },
    filterOption (input, option) {
      // console.log(input, option)
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.dateRange = []
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        dataInfoId: null
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const configIds = row.id ? [row.id] : this.ids
      this.$confirm({
        title: '确认处理所选中数据?',
        content: '当前选中编号为' + configIds + '的数据',
        onOk () {
          return faultStatus(configIds)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '处理成功',
                3
              )
          })
        },
        onCancel () {}
      })
    }
  }
}
</script>
